import { CreateDocumentRequest, Document } from './document';
import { Organisation, OrganisationType } from './organisation';
import { User } from './user';

export enum VerificationStatus {
	PENDING = 'pending',
	APPROVED = 'approved',
	DECLINED = 'declined',
	CANCELLED = 'cancelled',
	REQUEST_MORE_INFO = 'requestMoreInfo'
}

export interface Verification {
	id: string;
	userId: string;
	organisationId: string;
	verifierId: string;
	documentId?: string;

	/**
	 * What the organisation claimed. `issued` means they created the credential and
	 * can reproduce it, which is what makes partner-fulfilled delivery possible;
	 * `attested` means they only checked a document that originated elsewhere.
	 * Absent on records written before the intent vocabulary existed.
	 */
	verificationType?: 'request' | 'attestation' | 'authentication' | 'issuance';
	status: string;
	creationDateTime: string;
	updateDateTime: string;
	expirationDateTime?: string;
	txId?: string;
	blockchainId?: string;

	formData: { [key: string]: string };

	notes?: string; // approve notes or rejection notes
	expirationDate?: string; // set by the verifier

	messages?: [VerificationRequestMessages];
	fileKeys?: string[];
	identityId?: string;

	user?: User; // set on FE
	organisation?: Organisation; // set on FE
	document?: Document; // set on fe
}

export interface VerificationUser extends Verification {
	organisation: Organisation;
}

export interface VerificationOrganisation extends Verification {
	user: User;
}

export interface VerificationRequestMessages {
	userId: string;
	senderName: string;
	text: string;
	timestamp: string;
}

export interface CreateVerificationRequest {
	organisationId: string;
	organisationType?: OrganisationType; // only for frontend
	documentId?: string;
	onBehalfOf?: string; // userId of the child for proxy verification
	formData: { [key: string]: string };
	messages: [VerificationRequestMessages];
}

export interface CancelVerificationRequest {
	verificationId: string;
	documentId?: string;
}

export interface ApproveVerificationRequest {
	id: string;
	document?: CreateDocumentRequest;
	notes?: string;
}
export interface RejectVerificationRequest {
	id: string;
	notes?: string;
}

export interface ForwardVerificationRequest {
	id: string;
	organisationId: string;
}

export interface RequestMoreInfoVerificationRequest {
	id: string;
	message?: VerificationRequestMessages;
}

export interface AttachAdditionalVerificationFilesRequest {
	id: string;
	fileKeys: string[];
}
